module.exports = __webpack_public_path__ + "img/ead-viamaker.71495820.svg";